import {
  NS_GET_SUPERVISOR_DASHBOARD_DATA,
  NS_GET_SUPERVISOR_DASHBOARD_DATA_SUCCESS,
  NS_GET_SUPERVISOR_DASHBOARD_DATA_FAIL
} from '../../actions/ns/supervisorDashboard';

const initialState = {};

export default function supervisorDashboard(state = initialState, action) {
  switch (action.type) {
    case NS_GET_SUPERVISOR_DASHBOARD_DATA:
      return {
        ...state,
        payload: action.payload
      };
    case NS_GET_SUPERVISOR_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload
      };
    case NS_GET_SUPERVISOR_DASHBOARD_DATA_FAIL:
      return {
        ...state
      };
    default:
      return state;
  }
}
